// https://explorer.gobob.xyz/address/0xf630C8A7bC033FD20fcc45d8B43bFe92dE73154F
export const CROSS_CHAIN_CONTROLLER = '0xf630C8A7bC033FD20fcc45d8B43bFe92dE73154F';

// IPayloadsControllerCore https://explorer.gobob.xyz/address/0x17fa87007bfF1dC7e6b3a36ED936E6355e37237C
export const PAYLOADS_CONTROLLER = '0x17fa87007bfF1dC7e6b3a36ED936E6355e37237C';

// https://explorer.gobob.xyz/address/0x9fE056F44510F970d724adA16903ba5D75CC4742
export const PC_DATA_HELPER = '0x9fE056F44510F970d724adA16903ba5D75CC4742';

// https://explorer.gobob.xyz/address/0xb2C672931Bd1Da226e29997Ec8cEB60Fb1DA3959
export const GRANULAR_GUARDIAN = '0xb2C672931Bd1Da226e29997Ec8cEB60Fb1DA3959';

// https://explorer.gobob.xyz/address/0x19CE4363FEA478Aa04B9EA2937cc5A2cbcD44be6
export const GOVERNANCE_GUARDIAN = '0x19CE4363FEA478Aa04B9EA2937cc5A2cbcD44be6';

// https://explorer.gobob.xyz/address/0x90800d1F54384523723eD3962c7Cd59d7866c83d
export const EXECUTOR_LVL_1 = '0x90800d1F54384523723eD3962c7Cd59d7866c83d';

export const CHAIN_ID = 60808;
